import { format, formatDistanceToNow } from "date-fns";

export function formatPrice(amount: string, token: string): string {
  const num = parseFloat(amount);
  if (isNaN(num)) return `${amount} ${token}`;
  return `${num.toFixed(2)} ${token}`;
}

export function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  return format(d, "MMM d, yyyy");
}

export function formatRelativeDate(dateStr: string): string {
  return formatDistanceToNow(new Date(dateStr), { addSuffix: true });
}

export function formatArticlePrice(
  priceUsdc: string,
  priceEurc: string,
): string {
  const parts: string[] = [];
  if (priceUsdc) parts.push(`${parseFloat(priceUsdc).toFixed(2)} USDC`);
  if (priceEurc) parts.push(`${parseFloat(priceEurc).toFixed(2)} EURC`);
  return parts.join(" / ") || "Free";
}

export function truncateAddress(address: string): string {
  if (address.length <= 10) return address;
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}
